/* eslint-disable brace-style */
import { firstRight } from './../ricos-content';
import type { ToolbarSettingsFunctions } from './../ricos-types';
import type { TOOLBARS } from './../editor-common';
import { isiOS } from './../editor-common';

export const getToolbarSettings = <TbType extends TOOLBARS>(
  finaltoolbarSettings: ToolbarSettingsFunctions[],
  toolbarType: TbType
): Extract<ToolbarSettingsFunctions, { name: TbType }> | undefined => {
  const settings = finaltoolbarSettings.find(setting => setting.name === toolbarType) as
    | Extract<ToolbarSettingsFunctions, { name: TbType }>
    | undefined;
  return settings;
};

export const getShouldCreate = (
  isMobile: boolean,
  shouldCreateFn: ToolbarSettingsFunctions['shouldCreate']
): boolean => {
  const config = shouldCreateFn?.() || { desktop: true, mobile: { ios: true, android: true } };
  const shouldCreate = true;
  return (
    firstRight(shouldCreate, true, [
      [() => !isMobile, () => config.desktop],
      [() => isMobile && isiOS(), () => config.mobile?.ios],
      [() => isMobile && !isiOS(), () => config.mobile?.android],
    ]) ?? true
  );
};
